"use client";
import { FC, ReactNode } from "react";
import clsx from "clsx";

type MainWrapperProps = {
  children: ReactNode;
  className?: string;
  /** When set (e.g. `main-content`), enables skip-link focus via `tabIndex={-1}`. */
  id?: string;
};

const MainWrapper: FC<MainWrapperProps> = ({ children, className, id }) => {
  return (
    <main
      id={id}
      tabIndex={id ? -1 : undefined}
      className={clsx("home-main", className)}
    >
      {children}
    </main>
  );
};

export default MainWrapper;
